/*
 * RMA Mystery Vault Tee — gift-with-purchase cart logic (custom, no app).
 * Pairs with snippets/rma-mystery-gift.liquid. Loaded only when the mystery drop is enabled.
 *
 * Responsibilities:
 *   1. Size button click  -> add the mystery variant (qty 1, _mystery flag) -> re-render drawer.
 *   2. "Change size" click -> remove the mystery line -> re-render (reverts to the size picker).
 *   3. Reconcile: if the Liquid panel exposes [data-rma-mg-remove] (gift still in cart but the
 *      qualifying tee count dropped below the threshold), auto-remove the gift line.
 *
 * The Liquid panel re-renders on every cart change (it sits inside #CartDrawer, which Dawn
 * replaces wholesale on add / quantity-change). A MutationObserver on <cart-drawer> lets us
 * catch Dawn-initiated changes and run the reconcile pass.
 */
(function () {
  if (window.__rmaMysteryGiftInit) return;
  window.__rmaMysteryGiftInit = true;

  var busy = false;
  var lastRemoveKey = null;
  var lastRemoveAt = 0;

  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function setBusy(on) {
    busy = on;
    var panel = document.querySelector('.rma-mg');
    if (panel) panel.classList.toggle('is-busy', on);
  }

  // Re-render the cart drawer + header count from freshly rendered sections.
  function refresh() {
    var drawerUrl = route('cart_url', '/cart') + '?section_id=cart-drawer';
    var bubbleUrl = route('cart_url', '/cart') + '?section_id=cart-icon-bubble';
    return Promise.all([
      fetch(drawerUrl).then(function (r) { return r.text(); }),
      fetch(bubbleUrl).then(function (r) { return r.text(); }).catch(function () { return ''; })
    ]).then(function (results) {
      var drawerHtml = results[0];
      var bubbleHtml = results[1];

      var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var current = document.querySelector('#CartDrawer');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        // Dawn wires the overlay-close inside #CartDrawer, so re-bind it after replacing innerHTML.
        var drawer = document.querySelector('cart-drawer');
        var overlay = document.querySelector('#CartDrawer-Overlay');
        if (drawer && overlay && typeof drawer.close === 'function') {
          overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      }

      if (bubbleHtml) {
        var bDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        var bFresh = bDoc.getElementById('cart-icon-bubble');
        var bCurrent = document.getElementById('cart-icon-bubble');
        if (bFresh && bCurrent) bCurrent.innerHTML = bFresh.innerHTML;
      }
    });
  }

  function addMystery(variantId) {
    if (busy || !variantId) return;
    setBusy(true);
    fetch(route('cart_add_url', '/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _mystery: '1' } }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .catch(function (e) { console.error('[rma-mystery-gift] add failed', e); })
      .finally(function () { setBusy(false); reconcile(); });
  }

  function removeMystery(key) {
    if (busy || !key) return;
    // Guard against re-firing the same removal in a tight loop.
    var now = Date.now();
    if (key === lastRemoveKey && now - lastRemoveAt < 4000) return;
    lastRemoveKey = key;
    lastRemoveAt = now;
    setBusy(true);
    fetch(route('cart_change_url', '/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .catch(function (e) { console.error('[rma-mystery-gift] remove failed', e); })
      .finally(function () { setBusy(false); });
  }

  // If the panel says the gift should be pulled (dropped below threshold), do it.
  function reconcile() {
    if (busy) return;
    var flag = document.querySelector('#CartDrawer [data-rma-mg-remove]');
    if (flag) {
      var key = flag.getAttribute('data-rma-mg-remove');
      if (key) removeMystery(key);
    }
  }

  // Event delegation survives drawer re-renders (no re-binding needed).
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest && e.target.closest('.rma-mg__size');
    if (sizeBtn && sizeBtn.dataset.variantId) {
      e.preventDefault();
      addMystery(sizeBtn.dataset.variantId);
      return;
    }
    var changeBtn = e.target.closest && e.target.closest('.rma-mg__change');
    if (changeBtn && changeBtn.dataset.key) {
      e.preventDefault();
      removeMystery(changeBtn.dataset.key);
    }
  });

  function observe() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(reconcile, 120);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    observe();
    reconcile();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
